import { render, staticRenderFns } from "./SellerPaymentsList.vue?vue&type=template&id=2bfcab95&scoped=true&"
import script from "./SellerPaymentsList.vue?vue&type=script&lang=js&"
export * from "./SellerPaymentsList.vue?vue&type=script&lang=js&"
import style0 from "./SellerPaymentsList.vue?vue&type=style&index=0&id=2bfcab95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcab95",
  null
  
)

export default component.exports